import { render, staticRenderFns } from "./ItemDetailEntryLayout.vue?vue&type=template&id=5cd9ae2e&scoped=true"
import script from "./ItemDetailEntryLayout.vue?vue&type=script&lang=js"
export * from "./ItemDetailEntryLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd9ae2e",
  null
  
)

export default component.exports